import type { IShootingEventConfig } from '@dev-fast/types';

import { getStaticUrl } from '@app/shared/utils/static-url';

/*
  Note: Урл картинок выглядит чаще всего примерно так домен/название-ивента/год/папка-под-ангуляр/папка-под-медиа-для-ивента
  DOMAIN/EVENT_NAME/HOME_DIR_NAME/FILES_DIR_NAME
 */

/** Корень ивента */
const EVENT_NAME = '/neon-heist-event/';

/** Настройки для ивента с тиром*/
export const ShootingEventConfig: IShootingEventConfig = {
  eventNameLocale: 'Summer Slam Fest',
  eventLogoIconSrc: getStaticUrl(EVENT_NAME + 'event_icon.webp'),
  ///banner
  eventImageBannerSrc: getStaticUrl(EVENT_NAME + 'bg_out.webp'),
  eventImageBannerSrcMob: getStaticUrl(EVENT_NAME + 'main-banner.webp'),
  eventBannerSrc: 'url(' + getStaticUrl(EVENT_NAME + 'bg_out.webp') + ')',
  eventBannerMobSrc: 'url(' + getStaticUrl(EVENT_NAME + 'bg_out.webp') + ')',
  eventBannerBadge: getStaticUrl(EVENT_NAME + 'logo.webp'),
  //nav tab
  navTabArrowColorActive: '#EFF0CB',
  navTabArrowColorDisabled: '#DB871B',
  navTabIcons: [
    getStaticUrl(EVENT_NAME + 'watermelon-icon.webp'),
    getStaticUrl(EVENT_NAME + 'crab-icon.webp'),
    getStaticUrl(EVENT_NAME + 'cowboy-icon.webp'),
    getStaticUrl(EVENT_NAME + 'chest-icon.png'),
  ],
  navTabLock: [
    getStaticUrl(EVENT_NAME + 'lock-icon.png'),
    getStaticUrl(EVENT_NAME + 'lock-icon.png'),
    getStaticUrl(EVENT_NAME + 'lock-icon.png'),
    getStaticUrl(EVENT_NAME + 'chest-icon.png'),
  ],
  navBarFillerBackground: 'url(' + getStaticUrl(EVENT_NAME + 'filler-background.png') + ')',
  // Если не нужна отдельная картинка заблокированного предмета, оставить пустой
  roundsIcons: [getStaticUrl(EVENT_NAME + '1lvl.webp'), getStaticUrl(EVENT_NAME + '2lvl.webp'), getStaticUrl(EVENT_NAME + '3lvl.webp')],
  eventTicketSrc: getStaticUrl(EVENT_NAME + 'tickets.svg'),
  ballRangeConfig: {
    target: getStaticUrl(EVENT_NAME + '1lvl.webp'),
    targetHoverWeapon: '',
    targetHoverWeaponReady: '',
    targetHoverWeaponScope: getStaticUrl(EVENT_NAME + 'range1aim.svg'),
    targetPopFrame: 'url(' + getStaticUrl(EVENT_NAME + 'red-pop-frames.png') + ')',
    shotSound: ['NeonHunt_Shoot1_01', 'NeonHunt_Shoot1_02'],
    reloadSound: 'GUN_LOADING',
  },
  rifleRangeConfig: {
    target: getStaticUrl(EVENT_NAME + '2lvl.webp'),
    targetHoverWeapon: '',
    targetHoverWeaponReady: '',
    targetHoverWeaponScope: getStaticUrl(EVENT_NAME + 'range1aim.svg'),
    targetPopFrame: 'url(' + getStaticUrl(EVENT_NAME + 'blue-pop-frames.png') + ')',
    shotSound: ['NeonHunt_Shoot2_01', 'NeonHunt_Shoot2_02'],
    reloadSound: 'GUN_LOADING',
  },
  targetRangeConfig: {
    target: getStaticUrl(EVENT_NAME + '3lvl.webp'),
    targetHoverWeapon: '',
    targetHoverWeaponReady: '',
    targetHoverWeaponScope: getStaticUrl(EVENT_NAME + 'range1aim.svg'),
    targetPopFrame: 'url(' + getStaticUrl(EVENT_NAME + 'red-pop-frames.png') + ')',
    shotSound: ['NeonHunt_Shoot3_01', 'NeonHunt_Shoot3_02'],
    reloadSound: 'GUN_LOADING',
  },
};
